import * as React from "react";
import { Button, Container, Paper, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import { canonicalUrl } from "../../common/seo";

const PATH = "/contact-success";

export function ContactSuccessPage() {
  const title = "Message Sent | NWA Blog";
  const description = "Thanks for your message.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex,nofollow" />
        <link rel="canonical" href={canonicalUrl(PATH)} />
      </Helmet>

      <Paper elevation={2} sx={{ padding: "1rem", textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Thanks — message sent.
        </Typography>
        <Typography variant="body2" sx={{ marginTop: ".5rem" }}>
          If you don't hear back soon, feel free to try again.
        </Typography>

        <Button
          component={RouterLink}
          to="/"
          variant="outlined"
          size="small"
          sx={{
            marginTop: "1rem",
            textTransform: "none",
            color: "accent.main",
            borderColor: "accent.main",
            "&:hover": { borderColor: "accent.main" },
          }}
        >
          Back Home
        </Button>
      </Paper>
    </Container>
  );
}
